"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternalRedirectionUrl = exports.getActiveOnboardingStep = exports.getDefaultRouteFromNewPermissions = exports.getDefaultOrganizationRouteFromNewPermissions = exports.getDefaultDonorRoute = void 0;
const enums_1 = require("../enums");
const routes_1 = require("../routes");
const url_1 = require("./url");
const campaignListUrlObject = routes_1.RouteBuilders.buildCampaignListLink({
    isoLocale: null,
});
const campaignListUrl = (0, url_1.UrlBuilder)({
    pathname: campaignListUrlObject.path,
    searchParams: new URLSearchParams(campaignListUrlObject.searchParams),
}).build();
const getDefaultDonorRoute = () => {
    return routes_1.DonorRoutes.DonorPaymentTable;
};
exports.getDefaultDonorRoute = getDefaultDonorRoute;
const getDefaultRedirection = (newPermissions) => {
    if ((0, enums_1.hasPermissionOnAtLeastOneForm)(newPermissions)) {
        return campaignListUrl;
    }
    if ((0, enums_1.hasPermissionOnAtLeastOneFormPayment)(newPermissions)) {
        return routes_1.OrganizationRoutes.Payments;
    }
    if ((0, enums_1.hasPermissionOnContacts)(newPermissions)) {
        return routes_1.OrganizationRoutes.Contacts;
    }
    if ((0, enums_1.hasPermissionOnBank)(newPermissions)) {
        return routes_1.OrganizationRoutes.Bank;
    }
    if ((0, enums_1.hasPermissionOnBank)(newPermissions)) {
        return routes_1.OrganizationRoutes.Bank;
    }
    if ((0, enums_1.hasPermissionOnAtLeastOneFormReceipt)(newPermissions)) {
        return routes_1.OrganizationRoutes.Receipts;
    }
    if ((0, enums_1.hasPermissionOnUserManagement)(newPermissions)) {
        return routes_1.OrganizationRoutes.Settings;
    }
    if ((0, enums_1.hasPermissionOnTapToPay)(newPermissions)) {
        return routes_1.OrganizationRoutes.TapToPayInvitation;
    }
    return null;
};
const getDefaultOrganizationRouteFromNewPermissions = (newPermissions) => {
    const defaultOrganizationRoute = routes_1.OrganizationRoutes.Referral;
    const { generalPermissions, formPermissions } = newPermissions || {};
    if (!newPermissions || (!generalPermissions?.length && !formPermissions?.length)) {
        return defaultOrganizationRoute;
    }
    return getDefaultRedirection(newPermissions) || defaultOrganizationRoute;
};
exports.getDefaultOrganizationRouteFromNewPermissions = getDefaultOrganizationRouteFromNewPermissions;
const getDefaultRouteFromNewPermissions = ({ newPermissions, role, }) => {
    if (role === enums_1.UserRoles.Donor) {
        return (0, exports.getDefaultDonorRoute)();
    }
    return (0, exports.getDefaultOrganizationRouteFromNewPermissions)(newPermissions);
};
exports.getDefaultRouteFromNewPermissions = getDefaultRouteFromNewPermissions;
/**
 * Returns the active onboarding step if the user hasn't completed onboarding yet.
 * Returns null if onboarding is finished or not started.
 */
const getActiveOnboardingStep = (onboardingStep) => {
    if (!onboardingStep || onboardingStep === enums_1.OnboardingStep.Finished) {
        return null;
    }
    return onboardingStep;
};
exports.getActiveOnboardingStep = getActiveOnboardingStep;
const isInternalRedirectionUrl = ({ redirectionUrl, frontendUrl, }) => {
    if (!redirectionUrl) {
        return false;
    }
    const trimmed = redirectionUrl.trim();
    if (/^[/\\][/\\]/.test(trimmed)) {
        return false;
    }
    // Reject values containing whitespace; they are not valid redirect paths/URLs
    if (/\s/.test(trimmed)) {
        return false;
    }
    // Allow standard relative paths
    if (trimmed.startsWith("/")) {
        return true;
    }
    if (!frontendUrl) {
        return false;
    }
    try {
        const frontend = new URL(frontendUrl);
        const target = new URL(trimmed, frontend);
        // Disallow embedded credentials to avoid host-spoofing redirects
        if (target.username || target.password) {
            return false;
        }
        // Accept only same-origin absolute URLs
        return target.origin === frontend.origin;
    }
    catch {
        return false;
    }
};
exports.isInternalRedirectionUrl = isInternalRedirectionUrl;
